<template>

  <div class="card">
    <div class="card-header">
      {{ $t('Requisition') }}
    </div>
    <div
      class="card-body"
      :class="{'box-loading': loading}">
      
      <div
        v-if="job.requisition_id"
        class="mb-2">
        <router-link
          :to="{path: '/requisition/' + job.requisition_id._id }">
          {{ job.requisition_id.title }}
          </router-link>
      </div>

      <div v-if="!showSelect">
        <button
          v-if="!job.requisition_id"
          type="button"
          class="btn btn-sm btn-primary"
          @click="Show">Associar</button>
        <button
          v-if="job.requisition_id"
          type="button"
          class="btn btn-sm btn-secondary"
          @click="Disconnect">{{ $t('Disassociate') }}</button>  
      </div>

      <div
        v-if="showSelect">
        <select-requisition
          class="mb-2"
          @input="Connect">
          </select-requisition>
        <button
          type="button"
          class="btn btn-light"
          @click="Hide">
          {{ $t('Cancel') }}
          </button>
      </div>

    </div>
  </div>

</template>

<script>
import SelectRequisition from '@/components/Fields/SelectRequisition'

export default {
  name: 'JobProfileRequisition',
  components: {
    SelectRequisition
  },
  data () {
    return {
      showSelect: false,
      loading: false
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    }
  },
  created () {
  },
  methods: {
    Show () {
      this.showSelect = true
    },
    Hide () {
      this.showSelect = false
    },
    Connect (requisitionId) {
      this.loading = true

      this.$store.dispatch('updateJob', {
        _id: this.job._id,
        requisition_id: requisitionId
      })
      .then((result) => {
        this.loading = false
        this.Hide()
      })
    },
    Disconnect () {
      this.loading = true

      this.$store.dispatch('updateJob', {
        _id: this.job._id,
        requisition_id: null
      })
      .then((result) => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobProfile/JobProfileRequisition.vue